<template>
  <div class="search-form pr-2">
    <el-row :gutter="5">
      <el-col :span="8">
        <dict-select
          v-model="pdProcessDictCode"
          url="/factory/pd/process/dictionary/select"
          :placeholder="'请先选择工艺字典'"
          :options="{ label: 'processDictName', value: 'pdProcessDictCode' }"
          filterable
          size="small"
        >
        </dict-select>
      </el-col>
      <el-col :span="16">
        <el-select
          v-model="pdProcessDictFabricCode"
          :placeholder="pdProcessDictCode ? '请选择面料' : '请先选择工艺字典'"
          size="small"
          :disabled="!pdProcessDictCode"
          style="width:100%"
        >
          <el-option
            v-for="item in fabricOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pdProcessDictCode: '',
      pdProcessDictFabricCode: '',
      fabricOptions: [],
    }
  },
  watch: {
    pdProcessDictCode: {
      async handler(val) {
        this.pdProcessDictFabricCode = ''
        this.fabricOptions = (await this.getDictionaryFabric(val)) || []
      },
    },
    pdProcessDictFabricCode: {
      handler() {
        this.query()
      },
      immediate: true,
    },
  },
  methods: {
    query() {
      this.$emit('query', this.pdProcessDictFabricCode)
    },
    async getDictionaryFabric(pdProcessDictCode) {
      if (!pdProcessDictCode) return
      const params = { listPdProcessDictCode: [pdProcessDictCode] }
      const res = await this.$api
        .processDictionaryFabricSelectApi(params)
        .catch(() => null)
      if (!res) return
      const data = res.body.data || []
      return data.map((item) => {
        const {
          pdProcessDictFabricCode,
          fabricCategoryName,
          fabricNameRangeJson,
        } = item
        const fabricNameRanges = JSON.parse(fabricNameRangeJson || '[]')
        let label = fabricNameRanges.map((range) => range.label).join('、')
        if (!label) {
          label = fabricCategoryName
        } else {
          label = `${fabricCategoryName} (${label})`
        }
        return { value: pdProcessDictFabricCode, label }
      })
    },
  },
}
</script>
